import { TagColor } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import { apiClient } from 'modules/core/lib/mobx-rest'

export enum Status {
  NotAvailable = 'not_available',
  NotAuthenticated = 'not_authenticated',
  Authenticated = 'authenticated',
}
interface StatusResponse {
  status: Status
  refresh_token_expires_at: string
}
// TODO: make generic for other integrations
const STATUS_PATH = '/payroll_integrations/a3innuva/oauth/status'
export const LOGIN_PATH = '/payroll_integrations/a3innuva/oauth/login'
interface Data {
  companyId: number | undefined
  tenantId?: string | undefined
  organizationalUnitId?: string | undefined
  useOtherUsersTokensAsFallback?: boolean
}

type Responses = Record<string, StatusResponse>
class OauthService {
  private responses: Responses = {}

  statusLabel = () => {
    return {
      not_authenticated: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.login.status.not_linked.label'
      ),
      authenticated: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.login.status.linked.label'
      ),
      not_available: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.login.status.error.label'
      ),
    }
  }

  statusDescription = () => {
    return {
      not_authenticated: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.login.status.not_linked.description'
      ),
      authenticated: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.login.status.linked.description'
      ),
      not_available: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.login.status.error.description'
      ),
    }
  }

  statusToTagColor = () => {
    return {
      not_authenticated: TagColor.champagne,
      authenticated: TagColor.viridian,
      not_available: TagColor.radical,
    }
  }

  async getStatus(data: Data, bookkeeper_view: boolean) {
    const response = await this.getStatusResponse(data, bookkeeper_view)

    return response.status
  }

  async isNotAuthenticated(data: Data, bookkeeper_view: boolean) {
    const status = await this.getStatus(data, bookkeeper_view)

    return status === Status.NotAuthenticated
  }

  private async getStatusResponse(data: Data, bookkeeper_view: boolean) {
    const key = `${data.companyId}_${data.useOtherUsersTokensAsFallback}`

    const response = await apiClient().get(STATUS_PATH, {
      bookkeeper_view: bookkeeper_view,
      company_id: data.companyId,
      tenant_id: data.tenantId,
      organizational_unit_id: data.organizationalUnitId,
      use_other_users_tokens_as_fallback: data.useOtherUsersTokensAsFallback,
    })
    this.responses[key] = response

    return response
  }
}

export default new OauthService()
